import { z } from "zod";
import { OrderDirectionEnum } from "@tutellus/core-contracts-ifaces";
import { MediaFileSchema } from "../file/index.js";
export const PoapStatusEnum = {
    DRAFT: "DRAFT",
    ACCEPTED: "ACCEPTED",
    CREATING: "CREATING",
    CREATED: "CREATED",
    CANCELLED: "CANCELLED",
};
export const PoapSeoSchema = z.object({
    title: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    image: MediaFileSchema.optional().nullable(),
});
export const PoapCodeSchema = z.object({
    code: z.string(),
    limit: z.number(),
});
export const PoapSchema = z.object({
    _id: z.string(),
    hashId: z.string(),
    name: z.string(),
    description: z.string(),
    status: z.nativeEnum(PoapStatusEnum),
    eventDate: z.string(),
    perpetual: z.boolean(),
    energy: z.number(),
    ido: z.string().optional().nullable(),
    createdAt: z.string(),
    modifiedAt: z.string(),
    image: MediaFileSchema.optional().nullable(),
    video: MediaFileSchema.optional().nullable(),
    codes: z.array(PoapCodeSchema).optional().nullable(),
    howto: z.string().optional().nullable(),
    seo: PoapSeoSchema,
    tokenId: z.number().optional().nullable(),
});
export const PoapInputSchema = PoapSchema.omit({
    hashId: true,
    status: true,
    createdAt: true,
    modifiedAt: true,
    tokenId: true,
}).extend({
    ido: z.string(),
});
export const PoapMetadataSchema = z.object({
    numElements: z.number(),
    offset: z.number(),
    limit: z.number(),
    page: z.number(),
    pages: z.number(),
    orderBy: z.string(),
    orderDirection: z.nativeEnum(OrderDirectionEnum),
});
export const PoapAssetsSchema = z.object({
    items: z.array(PoapSchema),
    metadata: PoapMetadataSchema,
});
export const PoapSignatureSchema = z.object({
    signature: z.custom(),
    signer: z.string(),
    limit: z.number(),
});
export const CreatePoapResultSchema = z.object({
    safeTxHash: z.custom(),
});
